import { TriggerRequestProps } from '../../utils/requests-reducer/actions'

export const GET_LANDING_PAGE_REQUEST = 'GET_LANDING_PAGE_REQUEST'
export const GET_THEMES = 'GET_THEMES'

export const getLandingPageRequestId = (landingPageId: string) =>
  `${GET_LANDING_PAGE_REQUEST}/${landingPageId}`

export const getLandingPageRequest = (
  landingPageId: string,
): TriggerRequestProps => ({
  id: getLandingPageRequestId(landingPageId),
  url: `/landing_pages/${landingPageId}`,
  normalizer: GET_LANDING_PAGE_REQUEST,
  method: 'GET',
  data: {},
})

export const getThemes = (): TriggerRequestProps => ({
  id: GET_THEMES,
  url: `/themes`,
  normalizer: GET_THEMES,
  method: 'GET',
  data: {},
})
